import { computed } from 'vue'

import { getCategories } from '@backmarket/http-api/src/api-specs-model-comparison'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'

import { useRouteLocationWithLocale } from '~/composables/useRouteLocationWithLocale'

import { useCurrentCategory } from '../../composables/useCurrentCategory'
import { MODELS_COMPARISON } from '../../routes-names'

export function useFetchSuggestedCategories() {
  const { data } = useHttpFetch(getCategories)
  const resolveLocalizedRoute = useRouteLocationWithLocale()

  const suggestedCategories = computed(() => {
    const allCategories = data.value === null ? [] : data.value.categories

    const currentCategory = useCurrentCategory()

    return allCategories
      .filter(({ name }) => name !== currentCategory)
      .map((category) => ({
        image: category.image,
        title: category.label,
        link: resolveLocalizedRoute({
          type: 'internal',
          name: MODELS_COMPARISON.CATEGORY,
          params: { category: category.name },
        }),
      }))
  })

  const hasSuggestedCategories = computed(
    () => suggestedCategories.value?.length > 0,
  )

  return { suggestedCategories, hasSuggestedCategories }
}
